import { Link } from 'react-router-dom';

/**
 * AIInsightsPanel — Top 2-3 actionable root cause insights.
 * Clean, one-line each with severity indicator and CTA.
 */

const METRIC_LINKS = {
  'crash-free': '/metric/crash-free',
  'anr-rate': '/metric/anr-rate',
  'cold-start': '/metric/cold-start',
  'slow-rendering': '/metric/slow-rendering',
  'frozen-frames': '/metric/frozen-frames',
  'health-score': '/metric/health-score',
};

function getPriorityColor(priority) {
  if (priority === 'critical') return 'bg-red-500/20 text-red-400 border-red-500/30';
  if (priority === 'high') return 'bg-amber-500/20 text-amber-400 border-amber-500/30';
  return 'bg-blue-500/20 text-blue-400 border-blue-500/30';
}

function getPriorityLabel(priority) {
  if (priority === 'critical') return 'P0';
  if (priority === 'high') return 'P1';
  return 'P2';
}

export default function AIInsightsPanel({ rootCauses = [] }) {
  if (!rootCauses || rootCauses.length === 0) return null;

  // Show only top 3
  const topInsights = rootCauses.slice(0, 3);

  return (
    <div className="bg-surface-700/40 rounded-xl p-4 border border-surface-600/50">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-5 h-5 rounded-md bg-brand-500/20 flex items-center justify-center">
          <svg className="w-3 h-3 text-brand-400" fill="currentColor" viewBox="0 0 20 20">
            <path d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" />
          </svg>
        </div>
        <h3 className="text-sm font-semibold text-gray-200">AI Insights</h3>
        <span className="text-[10px] text-gray-600 ml-auto">Auto-analyzed</span>
      </div>

      <div className="space-y-2">
        {topInsights.map((insight, i) => {
          const metricLink = insight.metric ? METRIC_LINKS[insight.metric] || `/metric/${insight.metric}` : null;
          return (
            <div key={i} className="flex items-center gap-2 group">
              <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded border shrink-0 ${getPriorityColor(insight.priority)}`}>
                {getPriorityLabel(insight.priority)}
              </span>
              <p className="text-sm text-gray-300 truncate flex-1">
                {insight.title || insight.rootCause}
              </p>
              {metricLink && (
                <Link
                  to={metricLink}
                  className="text-xs text-brand-400 hover:text-brand-300 shrink-0 opacity-0 group-hover:opacity-100 transition-opacity"
                >
                  Investigate →
                </Link>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
